module.exports = __webpack_public_path__ + "static/media/lg-login.0ec4bce2.png";